import { render, staticRenderFns } from "./Tutorias.vue?vue&type=template&id=20f99cdf&"
import script from "./Tutorias.vue?vue&type=script&lang=js&"
export * from "./Tutorias.vue?vue&type=script&lang=js&"
import style0 from "./Tutorias.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports